// Simple i18n dictionary. Bahasa Indonesia = default, English = translation.
export const LOCALES = ["id", "en"];

export const T = {
  // Navigation
  "nav.home": { id: "Beranda", en: "Home" },
  "nav.about": { id: "Tentang", en: "About" },
  "nav.about.foundation": { id: "Tentang Yayasan", en: "About the Foundation" },
  "nav.about.history": { id: "Sejarah", en: "History" },
  "nav.about.vision": { id: "Visi & Misi", en: "Vision & Mission" },
  "nav.about.philosophy": { id: "Filosofi", en: "Philosophy" },
  "nav.about.values": { id: "Nilai-nilai", en: "Values" },
  "nav.programs": { id: "Program", en: "Programs" },
  "nav.programs.all": { id: "Semua Program", en: "All Programs" },
  "nav.projects": { id: "Proyek", en: "Projects" },
  "nav.impact": { id: "Impact", en: "Impact" },
  "nav.news": { id: "Berita", en: "News" },
  "nav.gallery": { id: "Galeri", en: "Gallery" },
  "nav.partners": { id: "Mitra", en: "Partners" },
  "nav.publications": { id: "Publikasi", en: "Publications" },
  "nav.team": { id: "Tim", en: "Team" },
  "nav.volunteer": { id: "Volunteer", en: "Volunteer" },
  "nav.donate": { id: "Donasi", en: "Donate" },
  "nav.contact": { id: "Kontak", en: "Contact" },

  // Hero
  "hero.badge": { id: "Yayasan Sauyunan Rahardja Nusantara", en: "Sauyunan Rahardja Nusantara Foundation" },
  "hero.title1": { id: "Menghubungkan", en: "Turning" },
  "hero.title2": { id: "harapan", en: "hope" },
  "hero.title3": { id: "menjadi", en: "into" },
  "hero.title4": { id: "dampak nyata", en: "real impact" },
  "hero.desc": {
    id: "Lembaga filantropi, kemanusiaan, dan pembangunan berkelanjutan yang menghubungkan masyarakat, pemerintah, dan mitra pembangunan dalam satu ekosistem dampak yang terintegrasi.",
    en: "A philanthropic, humanitarian, and sustainable development foundation that connects communities, government, and development partners in one integrated impact ecosystem.",
  },
  "hero.cta_donate": { id: "Berdonasi Sekarang", en: "Donate Now" },
  "hero.cta_volunteer": { id: "Jadi Relawan", en: "Become a Volunteer" },
  "hero.cta_learn": { id: "Kenali Kami", en: "Learn More" },
  "hero.badge_live": { id: "Sejak Nusantara, untuk Dunia", en: "From Nusantara, for the World" },
  "hero.card_title": { id: "Terintegrasi", en: "Integrated" },
  "hero.card_desc": { id: "7 bidang strategis · 5 tahap dampak · 9+ SDGs", en: "7 strategic areas · 5 impact stages · 9+ SDGs" },
  "hero.card_impact": { id: "Dampak", en: "Impact" },

  // Common CTAs
  "cta.read_more": { id: "Selengkapnya", en: "Learn more" },
  "cta.read": { id: "Baca", en: "Read" },
  "cta.see_all": { id: "Lihat Semua", en: "See all" },
  "cta.back_home": { id: "Kembali ke Beranda", en: "Back to Home" },
  "cta.contact_us": { id: "Hubungi Kami", en: "Contact Us" },

  // Footer
  "footer.newsletter_eyebrow": { id: "Bergabung dengan gerakan kami", en: "Join our movement" },
  "footer.newsletter_title": { id: "Berlangganan pembaruan program & cerita dampak Sauyunan.", en: "Subscribe to Sauyunan program updates & impact stories." },
  "footer.newsletter_placeholder": { id: "alamat@email.com", en: "your@email.com" },
  "footer.newsletter_button": { id: "Berlangganan", en: "Subscribe" },
  "footer.newsletter_note": { id: "Kami menghormati privasi Anda. Berhenti kapan saja.", en: "We respect your privacy. Unsubscribe anytime." },
  "footer.desc": {
    id: "Lembaga filantropi, kemanusiaan, dan pembangunan berkelanjutan yang menghubungkan harapan menjadi dampak nyata untuk masa depan Indonesia.",
    en: "A philanthropic, humanitarian, and sustainable development foundation turning hope into real impact for Indonesia's future.",
  },
  "footer.col_explore": { id: "Jelajahi", en: "Explore" },
  "footer.col_action": { id: "Aksi", en: "Take Action" },
  "footer.col_contact": { id: "Hubungi Kami", en: "Contact Us" },
  "footer.privacy": { id: "Kebijakan Privasi", en: "Privacy Policy" },
  "footer.terms": { id: "Syarat & Ketentuan", en: "Terms & Conditions" },

  // Locale switcher
  "locale.switch": { id: "EN", en: "ID" },
};

export function translate(key, locale = "id") {
  const entry = T[key];
  if (!entry) return key;
  return entry[locale] ?? entry.id ?? key;
}
